export const getSessionStartTime = session => {
  var _session$startTimeMs;
  return (_session$startTimeMs = session.startTimeMs) !== null && _session$startTimeMs !== void 0 ? _session$startTimeMs : 0;
};
export const getSessionEndTime = session => getSessionStartTime(session) + session.durationMinutes * 60000;

// When a session has actually started the BE sets `startedAt` (which may
// differ from the scheduled `startTimeMs`). Live alerts and live-session
// sorting should use this so they reflect when the session really went live.
export const getSessionStartedAt = session => {
  var _session$startedAt;
  return (_session$startedAt = session.startedAt) !== null && _session$startedAt !== void 0 ? _session$startedAt : getSessionStartTime(session);
};
export const getInProgressSessions = sessions => sessions.filter(s => s.status === 'STARTED').sort((a, b) => getSessionStartedAt(b) - getSessionStartedAt(a));
export const getInProgressSession = sessions => {
  var _getInProgressSession;
  return (_getInProgressSession = getInProgressSessions(sessions)[0]) !== null && _getInProgressSession !== void 0 ? _getInProgressSession : null;
};

// Picks the live session the alert should foreground:
//   1. A registered live session wins over any unregistered live session.
//   2. Among multiple registered live sessions, the most recently started wins.
//   3. With no registered live sessions, the most recently started live wins.
export const getPriorityInProgressSession = sessions => {
  var _ref, _inProgress$find;
  const inProgress = getInProgressSessions(sessions);
  return (_ref = (_inProgress$find = inProgress.find(s => !!s.joinUrl)) !== null && _inProgress$find !== void 0 ? _inProgress$find : inProgress[0]) !== null && _ref !== void 0 ? _ref : null;
};

// The "Join workshop" flow opens this far ahead of the scheduled start, so
// users can join slightly early — the BE only flips a session to STARTED once
// the host actually begins it.
export const JOIN_WINDOW_BEFORE_START_MS = 10 * 60000;

// A scheduled session is "starting soon" once we're within the join window
// before its scheduled start (but it hasn't started yet).
export const isStartingSoon = (session, now = Date.now()) => {
  const startTime = getSessionStartTime(session);
  return session.status === 'SCHEDULED' && startTime > now && startTime - now <= JOIN_WINDOW_BEFORE_START_MS;
};

// Sessions a user can join now: in-progress sessions, plus scheduled sessions
// inside the join window. In-progress (most recently started) are foregrounded
// ahead of starting-soon ones.
export const getJoinableSessions = (sessions, now = Date.now()) => [...getInProgressSessions(sessions), ...sessions.filter(s => isStartingSoon(s, now)).sort((a, b) => getSessionStartTime(a) - getSessionStartTime(b))];

// Picks the session the live / starting-soon alert should foreground,
// preferring a registered (joinable) session, then in-progress over
// starting-soon.
export const getPriorityJoinableSession = (sessions, now = Date.now()) => {
  var _ref2, _joinable$find;
  const joinable = getJoinableSessions(sessions, now);
  return (_ref2 = (_joinable$find = joinable.find(s => !!s.joinUrl)) !== null && _joinable$find !== void 0 ? _joinable$find : joinable[0]) !== null && _ref2 !== void 0 ? _ref2 : null;
};
export const getUpcomingSessions = (sessions, now = Date.now()) => sessions.filter(s => s.status === 'SCHEDULED' && getSessionStartTime(s) > now).sort((a, b) => getSessionStartTime(a) - getSessionStartTime(b));

// Upcoming sessions excluding the ones that are already within the join window
// (surfaced separately as the foregrounded joinable session), so they aren't
// listed twice.
export const getUpcomingSessionsNotStartingSoon = (sessions, now = Date.now()) => getUpcomingSessions(sessions, now).filter(s => !isStartingSoon(s, now));
export const getPastSessions = sessions => sessions.filter(s => s.status === 'ENDED').sort((a, b) => getSessionStartedAt(b) - getSessionStartedAt(a));